import { Link } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';

/**
 * Renders the "free, ad-supported" reminder under the hero player.
 *
 * Visible to: anonymous users + authenticated users without an
 * active subscription (i.e. anyone currently being served the
 * guest stream).
 *
 * Hidden for: users with subscriptionStatus in {trialing, active}.
 */
export function AdNotice() {
  const user = useAuthStore((s) => s.user);
  const isPaid =
    user?.subscriptionStatus === 'trialing' ||
    user?.subscriptionStatus === 'active';

  if (isPaid) return null;

  return (
    <div className="mt-4 flex items-center justify-between gap-3 rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-xs text-white/70">
      <span>Free radio · short Fonorex spots every few tracks</span>
      <Link
        to="/pricing"
        className="text-violet-300 hover:text-violet-200 whitespace-nowrap"
      >
        Remove ads →
      </Link>
    </div>
  );
}
